import { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function ListIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M10 20q-.825 0-1.412-.587A1.93 1.93 0 0 1 8 18q0-.824.588-1.413A1.93 1.93 0 0 1 10 16h10q.824 0 1.413.587Q22 17.176 22 18t-.587 1.413A1.93 1.93 0 0 1 20 20zm0-6q-.825 0-1.412-.588A1.93 1.93 0 0 1 8 12q0-.825.588-1.412A1.93 1.93 0 0 1 10 10h10q.824 0 1.413.588Q22 11.175 22 12t-.587 1.412A1.93 1.93 0 0 1 20 14zm0-6q-.825 0-1.412-.588A1.93 1.93 0 0 1 8 6q0-.824.588-1.412A1.93 1.93 0 0 1 10 4h10q.824 0 1.413.588Q22 5.175 22 6q0 .824-.587 1.412A1.93 1.93 0 0 1 20 8zM4 8q-.824 0-1.412-.588A1.93 1.93 0 0 1 2 6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4q.824 0 1.412.588Q6 5.175 6 6q0 .824-.588 1.412A1.93 1.93 0 0 1 4 8m0 6q-.824 0-1.412-.588A1.93 1.93 0 0 1 2 12q0-.825.587-1.412A1.93 1.93 0 0 1 4 10q.824 0 1.412.588Q6 11.175 6 12t-.588 1.412A1.93 1.93 0 0 1 4 14m0 6q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18q0-.824.587-1.413A1.93 1.93 0 0 1 4 16q.824 0 1.412.587Q6 17.176 6 18t-.588 1.413A1.93 1.93 0 0 1 4 20"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
